import { createRoot } from 'react-dom/client';
import { makeStore, type AppStore } from './app/store';
import { Providers } from './app/providers';
import { initTelemetry, Sentry } from './lib/observability/telemetry';
import './index.css';
// lazysizes — lazy loading natif des images <img loading="lazy"> et data-src
// (Sprint perfs) : auto-initialisation, pas de configuration nécessaire.
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

initTelemetry();

const store: AppStore = makeStore();

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary>
    <Providers store={store} />
  </Sentry.ErrorBoundary>,
);
